import { render, staticRenderFns } from "./leftSide.vue?vue&type=template&id=487b6e2a&scoped=true&"
import script from "./leftSide.vue?vue&type=script&lang=js&"
export * from "./leftSide.vue?vue&type=script&lang=js&"
import style0 from "./leftSide.vue?vue&type=style&index=0&id=487b6e2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487b6e2a",
  null
  
)

export default component.exports